import { Injectable } from '@angular/core';
import { JwtPayload, jwtDecode } from 'jwt-decode';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  decodedToken: { [key: string]: string } | undefined;

  constructor(private browserStorageService: BrowserStorageService) {}

  getEmailByToken(token: string): string {
    this.decodedToken = jwtDecode(token);
    return this.decodedToken ? this.decodedToken['email'] : '';
  }

  getIdAgencyByToken(token: string): string {
    this.decodedToken = jwtDecode(token);
    return this.decodedToken ? this.decodedToken['agencyId'] : '';
  }
  getIdUserByToken(token: string): string {
    this.decodedToken = jwtDecode(token);
    return this.decodedToken ? this.decodedToken['sub'] : '';
  }

  isValidRefreshToken() {
    const storedToken = this.browserStorageService.get('refresh_token');
    return this.isValid(storedToken);
  }
  isValidToken() {
    const storedToken = this.browserStorageService.get('token');
    return this.isValid(storedToken);
  }
  isValid(storedToken: string | null) {
    if (!storedToken) return false;
    const decodeToken = jwtDecode<JwtPayload>(storedToken);
    if (decodeToken && decodeToken?.exp) {
      const tokenDate = new Date(0);
      tokenDate.setUTCSeconds(decodeToken.exp);
      const today = new Date();
      // Margen de 60 segundos para evitar expiración durante requests
      return tokenDate.getTime() > today.getTime() + 60000;
    }
    return false;
  }
}
